"use strict";
// packages/shared-react/src/index.ts
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeToAgentAPI = exports.getIdTokenWithFallback = exports.GraphqlQuery = void 0;
// ------------------------------
// 1) Re-export React hooks & state
// ------------------------------
__exportStar(require("./hooks"), exports); // <- pulls everything from hooks/index.ts
__exportStar(require("./state"), exports);
var shared_1 = require("@heartcheck/shared");
Object.defineProperty(exports, "GraphqlQuery", { enumerable: true, get: function () { return shared_1.GraphqlQuery; } });
Object.defineProperty(exports, "getIdTokenWithFallback", { enumerable: true, get: function () { return shared_1.getIdTokenWithFallback; } });
Object.defineProperty(exports, "SubscribeToAgentAPI", { enumerable: true, get: function () { return shared_1.SubscribeToAgentAPI; } });
